import React from "react";
import { BrowserRouter, Route } from "react-router-dom";

import { LoginPage } from "../LoginPage";
import { MainSwitch } from "./MainSwitch";
import { AdminSwitch } from "./AdminSwitch";
import { OneLoginFlow } from "../LoginPage/components/OneLoginFlow";
import { CognitoFlow } from "../LoginPage/components/CognitoFlow";

export const RootRouter = () => {
  return (
    <BrowserRouter>
    
      <Route exact path="/login" component={LoginPage} />
      <Route exact path="/auth" component={OneLoginFlow}/>
      <Route exact path='/cognito' component={CognitoFlow}/>
      <MainSwitch />
      <AdminSwitch />
    </BrowserRouter>
  );
};
